import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";

const RevisedSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { width, height } = useWindowSize();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [revisionData, setRevisionData] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const { t } = useTranslation();
  const path = location.pathname;
  const isApproved = path.includes("revision-approved");
useEffect(() => {
    if (isApproved) {
      setShowConfetti(true);
      const timer = setTimeout(() => setShowConfetti(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [isApproved]);
  useEffect(() => {
    const storedData = localStorage.getItem("revisionData");
    if (storedData) {
      setRevisionData(JSON.parse(storedData));
    }
  }, []);

  if (!revisionData) {
    return (
      <Box
        sx={{
          textAlign: "center",
          mt: 10,
        }}
      >
        <Typography variant="h5" sx={{ fontFamily: "Poppins, sans-serif" }}>
           {t("subscriptionPage.no_revision_data")}
        </Typography>
        <CustomButton
          label={t("subscriptionPage.back_to_subscription")}
          size="medium"
          onClick={() => navigate("/subscription")}
          sx={{ mt: 2 }}
        />
      </Box>
    );
  }


  // Extract relevant fields from data
  const {
    plan_name,
    previous_worker_count,
    new_worker_count,
    pricing_details,
    billing_info,
    next_steps,
  } = revisionData;

  // Enable confetti only for approved case
  

  const handleBack = () => {
    navigate(isApproved ? "/dashboard" : "/subscription-plans");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
        py: 5,
      }}
    >
      {/* 🎊 Confetti for Approved */}
      {isApproved && showConfetti && <Confetti width={width} height={height} />}

      {/* ✅ or ❌ Icon */}
      {isApproved ? (
        <CheckCircleIcon
          sx={{ fontSize: isMobile ? 50 : 90, color: "#4caf50", mb: 2 }}
        />
      ) : (
        <CancelIcon
          sx={{ fontSize: isMobile ? 50 : 90, color: "#f44336", mb: 2 }}
        />
      )}

      {/* Main Heading */}
      <Typography
        variant="h4"
        sx={{
          fontSize: isMobile ? "35px" : "45px",
          fontFamily: "Poppins, sans-serif",
          fontWeight: "bold",
          mb: 1,
        }}
      >
     {isApproved
    ? t("subscriptionPage.workers_added_success")
    : t("subscriptionPage.revision_cancelled")}
      </Typography>

      {/* Sub Heading */}
      <Typography
        variant="body1"
        sx={{
          mb: 4,
          fontFamily: "Poppins, sans-serif",
          color: "#5E5C5C",
          maxWidth: 500,
          fontSize:"16px",
          lineHeight:1.2,
        }}
      >
         {isApproved
    ? t("subscriptionPage.workers_added_desc")
    : t("subscriptionPage.revision_cancelled_desc")}
      </Typography>

      {/* Info Card */}
      <Box
        sx={{
          bgcolor: "#F7F7F7",
          borderRadius: 2,
          py: 6,
          px: 4,
          mb: 3,
          width: "100%",
          maxWidth: 450,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        {[ 
          { label:t("subscriptionPage.plan_name"), value: plan_name },
          { label:  t("subscriptionPage.previous_workers"), value: previous_worker_count },
          { label:  t("subscriptionPage.new_worker_count"), value: new_worker_count },
          {
            label: t("subscriptionPage.previous_total"),
            value: `${pricing_details?.previous_total_amount.toFixed(2)} ${pricing_details?.currency}`,
          },
          {
            label:  t("subscriptionPage.new_total"),
            value: `${pricing_details?.new_total_amount.toFixed(2)} ${pricing_details?.currency}`,
          },
          {
            label:t("subscriptionPage.billing_cycle"),
            value: pricing_details?.billing_cycle,
          },
          { label:  t("subscriptionPage.price_change"), value: `${pricing_details?.price_change.toFixed(2)} ${pricing_details?.currency}` },
        ].map((row, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: i === 6 ? 0 : 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#5E5C5C",
              }}
            >
              {row.label}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                maxWidth: "55%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={String(row.value)}
            >
              {row.value}
            </CustomText>
          </Box>
        ))}
      </Box>


      {/* Button */}
      <CustomButton
        size="medium"
  label={isApproved ? t("subscriptionPage.go_to_dashboard") : t("subscriptionPage.back_to_subscription")}
        onClick={handleBack}
      />
    </Box>
  );
};

export default RevisedSuccess;






// import React, { useEffect, useState } from "react";
// import { Box, CircularProgress } from "@mui/material";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import { BASE_URL } from "../../../components/BaseUrl";
// import { decryptToken } from "../../../Utlis/Encryption";
// import { useSelector } from "react-redux";
// import { toast } from "react-hot-toast";

// const RevisedSuccess = () => {
//   const [loading, setLoading] = useState(true);
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const token = useSelector((state) => state.auth.token);
//   const decryptedToken = token ? decryptToken(token) : null;

//   useEffect(() => {
//     const activateSubscription = async () => {
//       try {
//         const subscription_id = searchParams.get("subscription_id");
//         const ba_token = searchParams.get("ba_token");
//         const tokenParam = searchParams.get("token");

//         console.log("🔍 Extracted Params:", {
//           subscription_id,
//           ba_token,
//           tokenParam,
//         });

//         if (!subscription_id || !ba_token || !tokenParam) {
//           console.error("❌ Missing PayPal redirect data");
//           toast.error("Invalid PayPal redirect data");
//           return;
//         }

//         const body = {
//           subscription_id,
//           ba_token,
//           token: tokenParam,
//         };

//         console.log("📤 Sending POST request to:", `${BASE_URL}/payments/activate-subscription`);
//         console.log("📦 Request Body:", body);

//         const res = await fetch(`${BASE_URL}/payments/activate-subscription`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${decryptedToken}`,
//           },
//           body: JSON.stringify(body),
//         });

//         console.log("📥 Response Status:", res.status);
//         const data = await res.json();
//         console.log("📥 Response Data:", data);

//         if (!res.ok) {
//           console.error("❌ Activation failed:", data.message);
//           throw new Error(data.message || "Activation failed");
//         }

//         console.log("✅ Subscription activated successfully!");
//         toast.success(data.message || "Subscription activated successfully!");

//          setTimeout(() => {
//           navigate("/payment/success", { state: data.data });
//         }, 1500);
//       } catch (err) {
//         console.error("🔥 API Error:", err);
//         toast.error(err.message || "Subscription activation failed");
//       } finally {
//         setLoading(false);
//       }
//     };

//     activateSubscription();
//   }, [searchParams, decryptedToken, navigate]);

//   return (
//     <Box
//       sx={{
//         height: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {loading && <CircularProgress />}
//     </Box>
//   );
// };

// export default RevisedSuccess;
